export default __webpack_public_path__ + "a3a2eb97a6ea65d58b87537683fe9b1e.png";